module.exports = __webpack_public_path__ + "img/display-2.48d99444.svg";